import React from "react";
import { priceFormat } from "@/utils/common";
import { renderCouponLabel } from "../renderCouponLabel";
import { processDescText } from "../../utils";
import "./index.less";
import { GoodsItem } from "@/pages/charge-vip/types";
import { processOssImage } from "@/utils/image";

export interface FillGoodsItemWithBuyProps {
  goodItem: GoodsItem;
  doBuyMemberGoods: (item: GoodsItem) => void;
  index: number;
  isDiscount: boolean;
  showCreditPrice: boolean;
  countdown?: string;
}

export const FillGoodsItemWithBuy: React.FC<FillGoodsItemWithBuyProps> = ({
  goodItem,
  doBuyMemberGoods,
  index,
  isDiscount,
  showCreditPrice,
  countdown
}) => {
  return (
    <div
      className={`fill-good-item-with-buy`}
      onClick={() => doBuyMemberGoods(goodItem)}
      key={`good-${goodItem?.skuId}-${index}`}
    >
      {renderCouponLabel({
        couponLabel: goodItem?.actDiscountLabel,
        discountType: goodItem?.discountType,
        countdown,
      })}

      {goodItem?.customPicture ? (
        <img
          className="good-img"
          src={processOssImage(goodItem?.customPicture)}
          alt={goodItem?.name || "--"}
        />
      ) : null}

      <div className="good-info-wrap">
        <div className="good-title-wrap">
          <div className="good-title">{goodItem?.name || "--"}</div>
          <div className="good-extra">
            {processDescText(goodItem?.desc).map((line: string, idx: number, array) => (
              <React.Fragment key={idx}>
                {line}
                {idx < array.length - 1 && <br />}
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="good-buy-wrap">
          {goodItem?.discountType === "COUPON_PRICE" &&
            goodItem?.discountBuyPrice !== null && (
              <div className="good-redpack">
                红包已减
                {priceFormat(goodItem?.salePrice - goodItem?.discountBuyPrice)}
                元
              </div>
            )}
          <div className="good-buy-btn">
            <span className="good-line-price">
              {isDiscount && `¥${priceFormat(goodItem?.salePrice)}`}
            </span>
            <span className="good-price-wrap">
              <span className="big-heavy-text-unit">¥</span>
              <span className="big-heavy-text">
                {priceFormat(
                  isDiscount ? goodItem?.discountBuyPrice : goodItem?.salePrice,
                )}
              </span>
            </span>
            {goodItem?.maxUseCreditAmount && showCreditPrice && (
              <span className="good-points-price">{`积分价：${goodItem?.maxUseCreditAmount}`}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
